import React from 'react';
import styled from 'styled-components';
import { InputNew as Input, Radio } from 'components';
import type { IMLSNumbers } from '@bb/users';
import { VerticalSpace } from '@brokerbay/design-components';
import { UserLocalOnboardingProfile } from '../types';
import { ListingLabelContext } from '../../../contexts';

export type OnboardingMemberNumbersProps = {
  mlsNumbers: UserLocalOnboardingProfile['mls_numbers'];
  onPrimaryChange: (
    newNumbers: UserLocalOnboardingProfile['mls_numbers'],
  ) => void;
};

const MlsBoardInputGroup = styled(Input.Group)`
  && {
    border: 1px solid #f5f5f5;
  }
`;

const MlsBoardInput = styled(Input)`
  && {
    width: 30%;
  }
`;

const MlsNumberInput = styled(Input)`
  && {
    width: 60% !important;
    background-color: #fff;
  }
`;

export const MLSNumberView: React.FC<{
  item: { board: string; number: string };
}> = ({ item }) => (
  <MlsBoardInputGroup>
    <MlsBoardInput readOnly value={item.board} />
    <MlsNumberInput readOnly value={item.number} />
  </MlsBoardInputGroup>
);

export const OnboardingMemberNumbers = (
  props: OnboardingMemberNumbersProps,
) => {
  const { mlsNumbers, onPrimaryChange } = props;

  const { getBoardName } = React.useContext(ListingLabelContext);

  const handlePrimaryChange = (numberIndex: number) => () => {
    const newNumbers = mlsNumbers.map((curItem, curIndex) => ({
      ...curItem,
      isPrimary: curIndex === numberIndex ? true : undefined,
    }));
    onPrimaryChange(newNumbers);
  };

  return (
    <VerticalSpace>
      {mlsNumbers.map((item, itemIndex) => {
        const formattedBoardName = getBoardName(item.board, false);
        return (
          <React.Fragment key={`${formattedBoardName}~${item.number}`}>
            <MLSNumberView item={{ ...item, board: formattedBoardName }} />
            <Radio
              checked={item.isPrimary}
              onChange={handlePrimaryChange(itemIndex)}
            >
              Primary MLS / Association
            </Radio>
          </React.Fragment>
        );
      })}
    </VerticalSpace>
  );
};
